import {createStyles, Grid, makeStyles} from "@material-ui/core";
import {useRefresh} from "ra-core";
import {useEffect, useRef, useState} from "react";
import {getAccessToken, getUser} from "../../authProvider";
import {useClosedSidebar} from "../../shared/hooks/useClosedSdebar";
import {BoardRoute} from "./BoardRoute";
import {clientNoJson} from "../../dataProvider";
import {PresenceQrGenerator} from "../../components/PresenceQrGenerator";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: "100%",
      height: "100%",
      overflow: "hidden",

      [theme.breakpoints.up("sm")]: {
        height: "100%",
        width: "100%",
      },
    },
    column: {
      padding: "0.5em",
      overflowY: "auto",
      maxHeight: "100%",
    },
  })
);

export const BoardRoutes = () => {
  const classes = useStyles();
  const refresh = useRefresh();
  const [soundEmitted, setSoundEmitted] = useState(false);
  const refreshTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useClosedSidebar();

  const user = getUser();

  useEffect(() => {
    let connectionString = `ws://${window.location.hostname}:${window.location.port}/ws/distribution/?token=${user.access}`;
    if (window.location.protocol === "https:")
      connectionString = `wss://${window.location.hostname}:${window.location.port}/ws/distribution/?token=${user.access}`;
    let active = true;
    let client: WebSocket | null = null;
    let reconnectTimer: ReturnType<typeof setTimeout> | null = null;

    const scheduleRefresh = () => {
      if (refreshTimer.current) {
        clearTimeout(refreshTimer.current);
      }
      refreshTimer.current = setTimeout(() => {
        refreshTimer.current = null;
        setSoundEmitted(false);
        refresh();
      }, 300);
    };

    const connect = () => {
      client = new WebSocket(connectionString);
      client.onmessage = scheduleRefresh;
      client.onclose = () => {
        if (active) {
          reconnectTimer = setTimeout(connect, 1000);
        }
      };
    };

    connect();

    return () => {
      active = false;
      if (reconnectTimer) clearTimeout(reconnectTimer);
      if (refreshTimer.current) clearTimeout(refreshTimer.current);
      client?.close();
    };
  }, [refresh, user.access]);


  var counter = 0
  let limitTime = 24 * 60 * 60 * 1000;

  useEffect(() => {
    const timer = setInterval(() => {
      if (counter < limitTime && (["admin"].includes(user.username) || user.username.toLowerCase().includes("bacheca"))) {
        getAccessToken()

        try {
          clientNoJson(`api/stay_tuned/`, {
            method: "POST",
          });
          if (counter !== 0 && (counter % 600000 === 0)) {
            setSoundEmitted(false);
            refresh();
          }
        } catch (err: any) {
        }

        counter = counter + 120000
      }

    }, 120000);

    return () => clearInterval(timer);
  }, []);

  function getSite() {
    let def_start_points: any = [];
    switch (user.username) {
      case "bacheca.sa":
        def_start_points = [705, 710, 1721, 1725, 1915, 4887, 7990, 73634, 78797, 91978];
        break;
      case "bacheca.na":
        def_start_points = [711];
        break;
      case "bacheca.mt":
        def_start_points = [38091];
        break;
    }
    return def_start_points
  }

  return (
    <Grid container className={classes.root}>
      <Grid item xs={6} className={classes.column}>
        <BoardRoute filters={{
          board_status: "to_load", start_points: getSite(),
        }} title="Da caricare/In carico"
          soundEmitted={soundEmitted} setSoundEmitted={setSoundEmitted}
        />
      </Grid>

      <Grid item xs={6} className={classes.column}>
        <BoardRoute filters={{ board_status: "ready_to_leave", start_points: getSite(), }} title="In partenza"
          soundEmitted={soundEmitted} setSoundEmitted={setSoundEmitted} />
      </Grid>

      <div style={{
        position: "fixed",
        bottom: "0",
        left: "50%",
        transform: "translate(-50%, 0)"
      }}>
        <PresenceQrGenerator {...{ compact: true, show_info: false }} />
      </div>
    </Grid>
  );
};
